import { FETCH_ALL_PAGE_SIZE } from '../constants/pagination';

export type PaginatedResponse<T> = {
  items: T[];
  itemCount: number;
  limit: number;
  offset: number;
};

export const fetchAllPages = async <TItem>(
  fetchPage: (query: { limit: string; offset: string }) => Promise<PaginatedResponse<TItem>>,
  pageSize = FETCH_ALL_PAGE_SIZE
): Promise<PaginatedResponse<TItem>> => {
  const items: TItem[] = [];
  let offset = 0;

  while (true) {
    const page = await fetchPage({ limit: String(pageSize), offset: String(offset) });
    items.push(...page.items);
    offset += page.items.length;
    if (page.items.length === 0 || offset >= page.itemCount) break;
  }

  return { items, itemCount: items.length, limit: items.length, offset: 0 };
};
